import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const VoiceConfig: React.FC = () => {
  return (
    <PageTemplate
      title="Voice Configuration"
      description="Configure voice settings for your AI agents"
    />
  );
};

export default VoiceConfig;